import { render, staticRenderFns } from "./ChatInput.vue?vue&type=template&id=e41634b8&"
import script from "./ChatInput.vue?vue&type=script&lang=js&"
export * from "./ChatInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VExpandTransition,VTextarea})
